/* esm.sh - light-bolt11-decoder@3.2.0 */
export * from "/*light-bolt11-decoder@3.2.0/esnext/light-bolt11-decoder.mjs";
export { default } from "/*light-bolt11-decoder@3.2.0/esnext/light-bolt11-decoder.mjs";
